import React from 'react'
import { BlueConicBoost, BlueConicRecommendationConfiguration } from '@pushly/models/lib/structs/journeys'
import { DomainDto } from '../../../../../../dtos/domain'
import { AllFilterRecordMap } from '../filters/types'

export type BlueConicConfigurationContext = {
    domain: DomainDto
    sourceConfig: BlueConicRecommendationConfiguration
    id: string
    filters: AllFilterRecordMap
    boosts: BlueConicBoost[]
    count: number
}
export const BlueConicConfigurationContext = React.createContext<BlueConicConfigurationContext>(null!)
